import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import '@/assets/styles/common.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'
import VueAppleSignin from 'vue-apple-signin';
import './router/router'
// import GAuth from 'vue-google-oauth2'

// const gauthOption = {
//   clientId: '977089567403-acin8gdc0lbm625s1bm8nqsq4cmeoh20.apps.googleusercontent.com',
//   scope: 'email',
// }


// Vue.use(GAuth, gauthOption)

Vue.prototype.$bus = new Vue()
Vue.use(GSignInButton);
Vue.use(FBSignInButton)
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
